import ToDateFilters from "../../LeftMenu/ToDateFilters";
import { useEffect, useMemo, useState } from "react";
import {
  buildFilters,
  setDateFilters,
} from "../../../utils/formatters/dateFormatter";
import { useDispatch, useSelector } from "react-redux";
import { saveSelectedDatePresets } from "../../../store/actions/layout";

export default function DatePresets(props) {
  const { type, select, filterType, defaultValues, currentTabId } = props;

  const { dateFiltersConfig, domain, customDatesFilterTypeMap } = useSelector(
    (state) => state.layout
  );

  const { name } = filterType;

  const { pageOriented } = dateFiltersConfig ?? {};

  const dateTypeValue = useMemo(() => {
    // user selected value from list is most actual
    const { value: userValue } = customDatesFilterTypeMap[name] ?? {};
    // default selected preset value from site config next
    const defaultValue = defaultValues && defaultValues[0];

    const value = userValue ?? defaultValue ?? null;

    // if there is a restriction on pages use only allowed values
    const restricted = (pageOriented ?? []).find(
      (page) =>
        page.pageUuids?.includes(currentTabId) || page.pageUuid === currentTabId
    );

    if (restricted?.dateTypes) {
      return restricted.dateTypes.find((type) => type === value);
    }

    return value;
  }, [
    currentTabId,
    customDatesFilterTypeMap,
    defaultValues,
    name,
    pageOriented,
  ]);

  const [dateType, setDateType] = useState({
    value: dateTypeValue,
  });

  useEffect(() => {
    setDateType({ value: dateTypeValue });
  }, [currentTabId, dateTypeValue]);

  const dispatch = useDispatch();

  function applyFilters({ from, to }) {
    if (from && to) {
      const filters = buildFilters(from, to, name);
      select(filters, type);
    }
  }

  function recentMonthsChange(option) {
    applyFilters(option);

    dispatch(
      saveSelectedDatePresets({ [name]: { value: dateType.value, ...option } })
    );
  }

  function setSelectedDateType(dateType) {
    setDateType(dateType);

    if (!dateType.value) {
      return select([{ key: name }], type); // handle "None..." option
    }

    applyFilters(setDateFilters(domain, dateType.value));

    dispatch(
      saveSelectedDatePresets({ [name]: dateType ?? { value: "none" } })
    );
  }

  function setCustomDateRange(from, to) {
    applyFilters({ from, to });

    dispatch(
      saveSelectedDatePresets({ [name]: { value: dateType.value, from, to } })
    );
  }

  return (
    <div>
      <ToDateFilters
        setSelectedDateType={setSelectedDateType}
        selectedDateType={dateType}
        recentMonthsChange={recentMonthsChange}
        dateFiltersConfig={dateFiltersConfig}
        domain={domain}
        dateConfig={{ setCustomDateRange }}
        dropDateGroup
        currentTabId={currentTabId}
        recentSelectedDatePreset={customDatesFilterTypeMap[name]}
      />
    </div>
  );
}
